import axios from 'axios'

export const SITE_UP_CHECK_URL = 'site-up'

export default {
  getSiteUp () {
    return axios.get(SITE_UP_CHECK_URL)
  },
}
